import { jsx as _jsx } from "react/jsx-runtime";
import { memo, Suspense, lazy } from 'react';
import { styled } from '@mui/material';
import { CarModels } from './types';
const Airplane = lazy(() => import(
// webpackChunkName: 'car-Airplane'
'./icons/airplane.svg'));
const ATV = lazy(() => import(
// webpackChunkName: 'car-ATV'
'./icons/atv.svg'));
const Boat = lazy(() => import(
// webpackChunkName: 'car-Boat'
'./icons/boat.svg'));
const BoxVan = lazy(() => import(
// webpackChunkName: 'car-BoxVan'
'./icons/boxvan.svg'));
const Microbus = lazy(() => import(
// webpackChunkName: 'car-Microbus'
'./icons/microbus.svg'));
const Moto = lazy(() => import(
// webpackChunkName: 'car-Moto'
'./icons/moto.svg'));
const Porsche = lazy(() => import(
// webpackChunkName: 'car-Moto'
'./icons/porsche.svg'));
const Pickup = lazy(() => import(
// webpackChunkName: 'car-Pickup'
'./icons/pickup.svg'));
const Samokat = lazy(() => import(
// webpackChunkName: 'car-Samokat'
'./icons/samokat.svg'));
const Scooter = lazy(() => import(
// webpackChunkName: 'car-Scooter'
'./icons/scooter.svg'));
const Suv = lazy(() => import(
// webpackChunkName: 'car-Suv'
'./icons/suv.svg'));
const Gelik = lazy(() => import(
// webpackChunkName: 'car-Suv'
'./icons/gelik.svg'));
const Coupe = lazy(() => import(
// webpackChunkName: 'car-Coupe'
'./icons/coupe.svg'));
const Hatch = lazy(() => import(
// webpackChunkName: 'car-Hatch'
'./icons/hatch-5.svg'));
const MotoSportTour = lazy(() => import(
// webpackChunkName: 'car-MotoSportTour'
'./icons/moto.sport-tour.svg'));
const SnowMobile = lazy(() => import(
// webpackChunkName: 'car-SnowMobile'
'./icons/snowmobile.svg'));
const WaterScooter = lazy(() => import(
// webpackChunkName: 'car-WaterScooter'
'./icons/waterscooter.svg'));
const Wagon = lazy(() => import(
// webpackChunkName: 'car-Wagon'
'./icons/wagon.svg'));
const Helicopter = lazy(() => import(
// webpackChunkName: 'car-Helicopter'
'./icons/helicopter.svg'));
const Car = lazy(() => import(
// webpackChunkName: 'car-Car'
'./icons/car.svg'));
const Prado = lazy(() => import(
// webpackChunkName: 'car-Car'
'./icons/prado.svg'));
const Fallback = styled('div')({
    display: 'inline-block',
    position: 'relative',
    maxWidth: '100%',
    width: 405,
    paddingBottom: '53%',
});
const CanPaintCar = [
    CarModels.boxVan,
    CarModels.car,
    CarModels.porsche,
    CarModels.gelik,
    CarModels.coupe,
    CarModels.hatch,
    CarModels.microbus,
    CarModels.pickup,
    CarModels.suv,
    CarModels.wagon,
    CarModels.prado,
];
export const CarIcon = memo(function CarIcon(props) {
    let icon;
    switch (props.model) {
        case CarModels.airplane:
            icon = _jsx(Airplane, { className: props.className });
            break;
        case CarModels.porsche:
            icon = _jsx(Porsche, { className: props.className });
            break;
        case CarModels.gelik:
            icon = _jsx(Gelik, { className: props.className });
            break;
        case CarModels.atv:
            icon = _jsx(ATV, { className: props.className });
            break;
        case CarModels.prado:
            icon = _jsx(Prado, { className: props.className });
            break;
        case CarModels.boat:
            icon = _jsx(Boat, { className: props.className });
            break;
        case CarModels.boxVan:
            icon = _jsx(BoxVan, { className: props.className });
            break;
        case CarModels.microbus:
            icon = _jsx(Microbus, { className: props.className });
            break;
        case CarModels.moto:
            icon = _jsx(Moto, { className: props.className });
            break;
        case CarModels.pickup:
            icon = _jsx(Pickup, { className: props.className });
            break;
        case CarModels.samokat:
            icon = _jsx(Samokat, { className: props.className });
            break;
        case CarModels.scooter:
            icon = _jsx(Scooter, { className: props.className });
            break;
        case CarModels.suv:
            icon = _jsx(Suv, { className: props.className });
            break;
        case CarModels.coupe:
            icon = _jsx(Coupe, { className: props.className });
            break;
        case CarModels.hatch:
            icon = _jsx(Hatch, { className: props.className });
            break;
        case CarModels.moto_sport_tour:
            icon = _jsx(MotoSportTour, { className: props.className });
            break;
        case CarModels.snow_mobile:
            icon = _jsx(SnowMobile, { className: props.className });
            break;
        case CarModels.water_scooter:
            icon = _jsx(WaterScooter, { className: props.className });
            break;
        case CarModels.wagon:
            icon = _jsx(Wagon, { className: props.className });
            break;
        case CarModels.helicopter:
            icon = _jsx(Helicopter, { className: props.className });
            break;
        default:
            icon = _jsx(Car, { className: props.className });
            break;
    }
    return _jsx(Suspense, { fallback: _jsx(Fallback, {}), children: icon });
});
export const isAllowedPaintModel = (model, design_package) => {
    return CanPaintCar.some((el) => el === model) && design_package;
};
